import { t } from "@lingui/macro";
import { Select, type SelectRef } from "@src/components/ui-kit";
import type { LargeSelectProps } from "@src/components/ui-kit/Select/LargeSelect";
import { observer, useLocalObservable } from "mobx-react-lite";
import { type FunctionComponent, useEffect, useRef } from "react";
import { BudgetItemSelectStore } from "./stores/budget-item-select.store";

type BudgetItemSelectProps = Omit<
  LargeSelectProps,
  "loadOptions" | "options" | "isLoading"
> & {
  projectId?: string;
};

export const BudgetItemSelect: FunctionComponent<BudgetItemSelectProps> =
  observer(function BudgetItemSelect({ projectId, ...props }) {
    const selectRef = useRef<SelectRef>(null);
    const { store } = useLocalObservable(() => ({
      store: new BudgetItemSelectStore(),
    }));

    useEffect(() => {
      if (!projectId) {
        store.clearOptions();
        return;
      }

      store.fetchOptions(projectId);
    }, [projectId]);

    return (
      <Select
        ref={selectRef}
        label={t`Budget Items`}
        placeholder={t`Select budget items`}
        options={store.options}
        isLoading={store.isLoading}
        noOptionsMessage={() =>
          projectId ? t`No budget items found` : t`Select project first`
        }
        {...props}
      />
    );
  });
